// src/modules/format.js
// 日期格式化 single source of truth。

const LOCALE = 'zh-CN';

export function formatDate(iso: string | number | Date): string {
  return new Date(iso).toLocaleDateString(LOCALE);
}

export function formatDateTime(iso: string | number | Date): string {
  return new Date(iso).toLocaleString(LOCALE);
}
